//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Shipping",
  props: {
    info: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      faq: [
        {
          title: 'Shipping Cost',
          value: 'Free',
          description: 'From CADs to casting to stone setting, all our designs are customizable and made just for you. Please allow two weeks for your order to arrive. '
        },
        {
          title: 'Delivery estimate',
          value: '10-14 days',
          description: 'From CADs to casting to stone setting, all our designs are customizable and made just for you. Please allow two weeks for your order to arrive. '
        },
        {
          title: 'Shipping Carrier',
          value: 'FedEx 2-day',
          description: 'From CADs to casting to stone setting, all our designs are customizable and made just for you. Please allow two weeks for your order to arrive. '
        },
        {
          title: 'Returns',
          value: 'Free 30 day returns',
          description: 'From CADs to casting to stone setting, all our designs are customizable and made just for you. Please allow two weeks for your order to arrive. '
        },
        {
          title: 'Warranty',
          value: '3 year warranty',
          description: 'From CADs to casting to stone setting, all our designs are customizable and made just for you. Please allow two weeks for your order to arrive. '
        },
      ],
      openIndex: -1
    }
  },
  methods: {
    close() {
      this.$parent.$emit('changeStage', 'configurator')
    }
  },
}
